'use strict';

angular.module('amexReconciliationApp')
  .service('ReallocateTransactionsService', function (ReallocateTransactionsRepository,
                                                      TransactionsStatusChangeService,
                                                      SiteConfigModel,
                                                      $q,
                                                      TransactionService) {
    var self = this;

    self.reallocateTransactions = function(transactions, reallocatedFields, description) {
      var transactionIds = _.map(transactions, function(transaction) {
        return transaction.id;
      });

      return ReallocateTransactionsRepository.reallocateTransactionAllocations({
        transactionIds: transactionIds,
        reallocatedFields: reallocatedFields,
        description: description
      }).then(function() {
        approveIfApprovalEnabled(transactions)
          .finally(TransactionService.getTransactions);
      });
    };

    function approveIfApprovalEnabled(transactions) {
      if (SiteConfigModel.approveOnReallocationEnabled()) {
        var transactionsToApprove = _.filter(transactions, function (transaction) {
          return TransactionsStatusChangeService.canBeApprovedOrSubmitted(transaction);
        });

        if (!_.isEmpty(transactionsToApprove)) {
          return TransactionsStatusChangeService.changeStatus(transactionsToApprove);
        }

      }
      return $q.when();
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ReallocateTransactionsService.js
// module id = 643
// module chunks = 0